import { useState, useContext } from 'react';
import { ctxMap } from '@/contexts/MapContext';
import MultiGoiGroupSelector from '@/components/common/selection/MultiGoiGroupSelector';

export default function GoiGroupSelector() {
  const [searchText, setSearchText] = useState<string | undefined>(undefined);
  const mapCtx = useContext(ctxMap);

  if (!mapCtx) {
    return;
  }

  return (
    <MultiGoiGroupSelector
      selectedGoiGroups={mapCtx.selectedGoiGroup}
      setSelectedGoiGroups={mapCtx.setSelectedGoiGroup}
      searchText={searchText}
      setSearchText={setSearchText}
      maxElementNumber={10}
    />
  );
}
